import { render } from "./App.vue?vue&type=template&id=5c2e9088&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5c2e9088&lang=scss"
import "./App.vue?vue&type=style&index=1&id=5c2e9088&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2e9088"]])

export default __exports__